import { doc, onSnapshot } from "firebase/firestore";
import { useEffect, useMemo, useState } from "react";
import { firestore } from "../firebase";
import {
  mapDocToStripeConnectInfo,
  StripeConnectInfo,
  StripeConnectInfoCollection,
} from "../types/StripeConnectInfo";

export function useStripeConnectInfo(projectId: string | null) {
  const [stripeConnectInfo, setStripeConnectInfo] =
    useState<StripeConnectInfo | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!projectId) {
      setIsLoading(false);
      setError("Project ID is missing");
      return;
    }

    setIsLoading(true);
    const unsubscribe = onSnapshot(
      doc(firestore, StripeConnectInfoCollection, projectId),
      (doc) => {
        try {
          setStripeConnectInfo(mapDocToStripeConnectInfo(doc.data()));
          setIsLoading(false);
          setError(null);
        } catch (err) {
          setError("Failed to load project details");
          setStripeConnectInfo(null);
          setIsLoading(false);
        }
      },
    );

    return () => unsubscribe();
  }, [projectId]);

  return useMemo(
    () => ({ stripeConnectInfo, isLoading, error }),
    [stripeConnectInfo, isLoading, error],
  );
}
